// @ts-nocheck
import { addSndProduct, ScratchAndDentsProductParameter } from "@store/Framework/Services/ScratchAndDentService";
import {
    ApiHandler,
    createHandlerChainRunner,
    HasOnError,
    HasOnSuccess,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@toolkit/Modules/client-framework/HandlerCreator";

type HandlerType = ApiHandler<
    { sndProduct: ScratchAndDentsProductParameter } & HasOnSuccess<string> & HasOnError<string>,
    string
>;

export const DispatchBeginAddProduct: HandlerType = props => {
    props.dispatch({
        type: "Store/Components/ScratchAndDentForm/BeginAddProduct",
    });
};

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = { ...props.parameter };
};

export const RequestDataFromApi: HandlerType = async props => {
    try {
        const result = await addSndProduct(props.apiParameter.sndProduct);
        props.apiResult = result;
    } catch (error) {
        if ("errorMessage" in error) {
            props.parameter.onError?.(error.errorMessage as string);
            props.dispatch({
                type: "Store/Components/ScratchAndDentForm/CompleteAddProduct",
            });
        }
        return false;
    }
};

export const DispatchcompleteAddProduct: HandlerType = props => {
    props.dispatch({
        type: "Store/Components/ScratchAndDentForm/CompleteAddProduct",
    });
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    markSkipOnCompleteIfOnSuccessIsSet(props);
    props.parameter.onSuccess?.(props.apiResult);
};

export const chain = [
    DispatchBeginAddProduct,
    PopulateApiParameter,
    RequestDataFromApi,
    DispatchcompleteAddProduct,
    ExecuteOnSuccessCallback,
];

const addProduct = createHandlerChainRunner(chain, "AddProduct");
export default addProduct;
